/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import React from "react";
import styled from "@mui/styled-engine-sc";
import NativeSelect from "@mui/material/NativeSelect";

const StyledNativeSelect = styled(({ ...props }) => <NativeSelect {...props} />)`
  && {
  }
`;

export { StyledNativeSelect };
